<template>
  <nav v-if="result.total !== 0" aria-label="Pagination">
    <ul class="menu pagination align-center">
      <li 
        v-for="n in pageCount"
        :key="n" 
        :class="{ 'menu-text': n == currentPage }">
        <span v-if="n == currentPage">
          <strong>{{ n }}</strong>
        </span>
        <a v-else @click.prevent="toPage(n)" href="#">{{ n }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
const VueScrollTo = require('vue-scrollto')
  
export default { 
  name: 'Pagination',
  props: {
    itemsPerPage: {
      type: Number,
      required: true
    }
  },
  methods: {
    toPage (page) {
      this.$emit('to-page', page)
      this.$nextTick(() => {
        VueScrollTo.scrollTo('#list-view-app', 100, {offset: -20})
      })
    }
  },
  computed: {
    currentPage () {
      return this.$store.getters.params.paging.page
    },
    pageCount () {
      let total = this.result.total
      let per_page = this.itemsPerPage
      if (total > per_page) {
        return Math.ceil(total / per_page)
      } else {
        return 1
      }
    },
    result () {
      return this.$store.getters.result
    }
  }
}
</script>
